import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DirectDebitService } from '../../../services/direct-debit/direct-debit.service';

@Component({
  selector: 'app-dnd',
  templateUrl: './dnd.component.html',
  styleUrls: ['./dnd.component.css']
})
export class DndComponent implements OnInit {
  @Output() response = new EventEmitter<any>();
  @Output() reset = new EventEmitter<any>();
  // @Input() loading(_loading: boolean) {
  //   this._loading = _loading;
  // };

  @Input() set direct_debit(_direct_debit: any) {
    const loteAnterior = this._direct_debit?._id;
    this._direct_debit = _direct_debit;
    // Al cambiar de lote, el archivo cargado es del lote anterior: se descarta para que no
    // parezca que este lote ya tiene su respuesta lista (y para no conciliarlo por error).
    if (loteAnterior && loteAnterior !== _direct_debit?._id) {
      this.clearState();
    }
  };

  @Input() set config(config: any) {
    this.config_read = config;
  };

  _loading = false;
  resumen_response: any;
  _direct_debit: any;
  verified = false;
  config_read: any;
  error = false;
  // Motivo puntual del rechazo cuando NO es un problema del archivo (ej: el backfill de mora del
  // día no corrió). Si está seteado, el template lo muestra en vez de "Archivo no válido...".
  error_message = '';


  constructor(
    private directDebitService: DirectDebitService,
  ) { }

  ngOnInit(): void {
    
  }

  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef | undefined;
  files: any[] = [];

  /**
   * on file drop handler
   */
  onFileDropped(files: File[]) {
   
    this.prepareFilesList(files);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler($event: any) {
    let files = ($event.target as HTMLInputElement).files;
    this.prepareFilesList(files);
  }

  /**
   * Limpia el archivo cargado y el resultado de su lectura (cambio de lote).
   */
  clearState() {
    this.files = [];
    this.verified = false;
    this.error = false;
    this.error_message = '';
    this.resumen_response = null;
    this._loading = false;
    if (this.fileDropEl && this.fileDropEl.nativeElement) {
      this.fileDropEl.nativeElement.value = '';
    }
    this.reset.emit(true);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    if (this.files[index].progress < 100) {
      console.log("Upload in progress.");
      return;
    }
    this.files.splice(index, 1);
    this.verified = false;
    this.reset.emit(true);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
   
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
   
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: any) {
    this.error = false;
    this.verified = false;
    this._loading = true;
    this.files = [];
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    if (this.fileDropEl && this.fileDropEl.nativeElement) {
      this.fileDropEl.nativeElement.value = "";
    }
    this.uploadFilesSimulator(0);
    this.readFileService();
  }

  readFileService = async () => {
    this.verified = false;
    this.error = false;
    this.error_message = '';
    try{
      let lote = this._direct_debit.manual_lote?this._direct_debit.manual_lote.padStart(10, '0').toString(): this._direct_debit.lote.padStart(10, '0').toString();
      let lote_sin_ceros = this._direct_debit.lote.toString();
      let config = this.config_read.config;
      let response;

      // 'conciliation' → el backend valida las precondiciones del día antes de parsear el archivo.
      if(this.config_read.custom_function) {
        response = await this.directDebitService.readDirectDebitCustomFile(config, this.files[0], this.config_read.custom_function, 'conciliation');

      } else {
        response = await this.directDebitService.readDirectDebitFile(config, this.files[0], 'conciliation');

      }

      // El backend rechazó la carga por precondiciones (no es un problema del archivo).
      if(response?.code === 'PRECONDITION_JOBS_MISSING' || response?.code === 'PRECONDITION_CHECK_ERROR') {
        this._loading = false;
        this.error = true;
        this.error_message = response.description;
        this.response.emit(null);
        return;
      }
      // let config = '[{"length":140,"attr":[{"name":"TIPOREG","length":2},{"name":"RIF","length":9,"deleteZero":true},{"name":"DIGVERIFRIF","length":1,"deleteZero":true},{"name":"CANTTRANS","length":10,"deleteZero":true},{"name":"MONTO","length":13,"formatAmount":".","deleteZero":true},{"name":"FEENVIO","length":10},{"name":"LOTE","length":10,"deleteZero":true},{"name":"REF1","length":20,"deleteZero":true},{"name":"REF2","length":20,"deleteZero":true},{"name":"REF3","length":20,"deleteZero":true},{"name":"FVALOR","length":10},{"name":"FCULMINA","length":10},{"name":"CODNEGO","length":10,"deleteZero":true}]},{"length":428,"attr":[{"name":"TIPOREG","length":2},{"name":"CEDULA","length":9,"deleteZero":true},{"name":"DIGVERIFCED","length":1,"deleteZero":true},{"name":"CODCLTE","length":20,"deleteZero":true},{"name":"TIPAGO1","length":1},{"name":"TIPCTA1","length":2,"deleteZero":true},{"name":"NROCTA1","length":20},{"name":"NROTARJ1","length":20},{"name":"CVV2","length":3},{"name":"FEXP1","length":4},{"name":"MONTOC1","length":13,"deleteZero":true,"formatAmount":"."},{"name":"TIPAGO2","length":1},{"name":"TIPCTA2","length":2},{"name":"NROCTA2","length":20},{"name":"NROCTARJ2","length":20},{"name":"CVV2","length":3},{"name":"FEXP2","length":4},{"name":"MONTOC2","length":13,"deleteZero":true,"formatAmount":"."},{"name":"FECHVAL","length":10},{"name":"MONTO","length":13,"deleteZero":true,"formatAmount":"."},{"name":"REFDEB","length":20},{"name":"EMAIL","length":50,"deleteZero":true},{"name":"STATUS","length":5},{"name":"DESCSTA","length":120},{"name":"FCOBRO","length":10},{"name":"TOTCOB","length":13,"deleteZero":true,"formatAmount":"."},{"name":"CANINT","length":2},{"name":"NUETDC","length":20},{"name":"NUECVV2","length":3},{"name":"NUEFVEN","length":4}]},{"length":434,"attr":[{"name":"TIPOREG","length":2},{"name":"FECHA","length":24},{"name":"CODERROR","length":5},{"name":"DESCRIPCION","length":250},{"name":"CODCLTE","length":20},{"name":"REFDEB","length":20},{"name":"TIPAGO1","length":1},{"name":"TIPCTA1","length":2},{"name":"NROCTA1","length":20},{"name":"NROTARJ1","length":20},{"name":"CVV2","length":3},{"name":"FEXP1","length":4},{"name":"TIPAGO2","length":1},{"name":"TIPCTA2","length":2},{"name":"NROCTA2","length":20},{"name":"NROTARJ2","length":20},{"name":"CVV2","length":3},{"name":"FEXP2","length":4},{"name":"MONTO","length":13,"deleteZero":true,"formatAmount":"."}]}]';
      // let response = await this.directDebitService.readDirectDebitFile(config, this.files[0]);
      let header = this.getHeader(response.data, this.config_read);

 
      this._loading = false;
      let lote_crudo = header['LOTE'] ?? "";
      const loteIncludes = this.config_read?.bank?.acron === 'Provincial' && lote_crudo.includes(lote_sin_ceros);

      if(lote===header['LOTE'].padStart(10, '0').toString() || (loteIncludes)) { // aqui tendría que validar el lote
      //if(true) { // aqui tendría que validar el lote
        this.verified = true;
        let resumen = this.resumen(response.data, this.config_read);
        this.resumen_response = resumen;
        this.response.emit({response, file: this.files[0], resumen});
      } else {
        this.error = true;
        this.response.emit(null);
      }
    } catch(error) {
      console.log(error);
      this._loading = false;
      this.error = true;
      this.response.emit(null);
      console.log('entra por la via del error');
      console.log(false);
    }
  }

  resumen = (obj: any, config: any) => {
    let flags: any = [];
    if(config?.bank?.acron==='Venezuela') {
      flags = ["En Proceso (Cobranza)"];
      return obj.reduce((accum: { redflags: any, count_02: number, count: number, total_amount_02: number }, curr: any, index: number) => {
        accum.count_02 += (curr.TIPOREG === '02') ? 1 : 0;
        // verifico si no tiene error 
        if(curr.TIPOREG === '02'){
          accum.count+= (curr.TIPOREG === '02') ? parseFloat(curr.MONTO) : 0;
          if(!obj.some((row: any)=>row.REFDEB===curr.REFDEB && row.TIPOREG==='03')) {
            accum.total_amount_02 += (curr.TIPOREG === '02') ? parseFloat(curr.MONTO) : 0;
          }
          if(flags.includes(curr.DESCSTA.trim())) {
            accum.redflags.push(index+1);
          }
        }
        return accum;
      }, { redflags: [], count_02: 0, count: 0, total_amount_02: 0 });
    } else {
      return null;
    }
  }

  getHeader = (obj: any, config: any) => {
    if(config?.bank?.acron==='Mercantil' || config?.bank?.acron==='Bancaribe') {
      return obj.find((row: any) => row.TIPOREG.toString()==="1" );
    }else if(config?.bank?.acron==='Provincial') {
      return obj.find((row: any) => row.TIPOREG.toString()==="6110");
    }  else {
      return obj.find((row: any) => row.TIPOREG.toString()==="01" );
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

}
